module.exports = "/assets/cd419d99795fbf06927c4ff37cf3e44f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/RZ.png
// module id = 2925
// module chunks = 0